// import { useState } from "react";

// export default function Navbar() {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <nav className="flex items-center justify-between px-6 md:px-16 py-5 relative bg-black text-white">
//       {/* LOGO */}
//       <div className="w-50 md:w-56">
//         <img
//           src="https://superstrengthcables.in/wp-content/uploads/2026/04/ChatGPT-Image-Apr-14-2026-04_26_45-PM-768x512.png"
//           alt="Cable Logo"
//           className="w-full h-24 md:h-32 object-contain"
//         />
//       </div>

//       {/* DESKTOP MENU */}
//       <ul className="hidden md:flex items-center gap-8 text-sm font-medium uppercase">
//         <li>
//           <a href="/cable/" className="hover:text-yellow-400">
//             Home
//           </a>
//         </li>
//         <li>
//           <a href="/work" className="hover:text-yellow-400">
//             Works
//           </a>
//         </li>
//         <li>
//           <a href="/service" className="hover:text-yellow-400">
//             Services
//           </a>
//         </li>
//         <li>
//           <a href="/about" className="hover:text-yellow-400">
//             About Us
//           </a>
//         </li>
//         <li>
//           <a href="/testimonial" className="hover:text-yellow-400">
//             Testimonial
//           </a>
//         </li>
//         <li>
//           <a href="/contact" className="hover:text-yellow-400">
//             Contact
//           </a>
//         </li>

//         <li>
//           <a
//             href="/contact"
//             className="bg-yellow-400 text-black px-5 py-2 rounded-full hover:bg-yellow-300 transition"
//           >
//             LET'S TALK
//           </a>
//         </li>

//         <li>
//           <button
//             onClick={() => window.open("/catalogue SS.pdf", "_blank")}
//             className="border border-yellow-400 text-white px-5 py-2 rounded-full hover:bg-yellow-400 hover:text-black transition"
//           >
//             Catalogue
//           </button>
//         </li>
//       </ul>

//       {/* MOBILE BUTTON */}
//       <button
//         className="md:hidden text-3xl focus:outline-none"
//         onClick={() => setIsOpen(!isOpen)}
//       >
//         ☰
//       </button>

//       {/* MOBILE MENU */}
//       {isOpen && (
//         <div className="absolute top-20 left-0 w-full bg-black/95 backdrop-blur-md p-6 md:hidden">
//           <ul className="flex flex-col gap-5 text-center uppercase">
//             <li>
//               <a href="/" className="block hover:text-yellow-400">
//                 Home
//               </a>
//             </li>
//             <li>
//               <a href="/work" className="block hover:text-yellow-400">
//                 Works
//               </a>
//             </li>
//             <li>
//               <a href="/service" className="block hover:text-yellow-400">
//                 Services
//               </a>
//             </li>
//             <li>
//               <a href="/about" className="block hover:text-yellow-400">
//                 About Us
//               </a>
//             </li>
//             <li>
//               <a href="/testimonial" className="block hover:text-yellow-400">
//                 Testimonial
//               </a>
//             </li>
//             <li>
//               <a href="/contact" className="block hover:text-yellow-400">
//                 Contact
//               </a>
//             </li>

//             <li className="pt-3">
//               <a
//                 href="/contact"
//                 className="bg-yellow-400 text-black px-6 py-3 rounded-full inline-block hover:bg-yellow-300 transition"
//               >
//                 LET'S TALK
//               </a>
//             </li>

//             <li>
//               <button
//                 onClick={() => window.open("/catalogue SS.pdf", "_blank")}
//                 className="border border-yellow-400 text-white px-5 py-2 rounded-full hover:bg-yellow-400 hover:text-black transition"
//               >
//                 Catalogue
//               </button>
//             </li>
//           </ul>
//         </div>
//       )}
//     </nav>
//   );
// }

import { useState } from "react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="relative flex items-center justify-between px-4 sm:px-6 md:px-16 py-4 bg-black text-white">
      {/* LOGO */}
      <div className="w-40 md:w-48">
        <img
          src="/logo.png"
          alt="Cable Logo"
          className="w-full h-20 md:h-24 object-contain"
        />
      </div>

      {/* DESKTOP MENU */}
      <ul className="hidden lg:flex items-center gap-6 xl:gap-8 text-sm font-medium uppercase">
        <li>
          <a href="/" className="hover:text-yellow-400">
            Home
          </a>
        </li>
        <li>
          <a href="/work" className="hover:text-yellow-400">
            Works
          </a>
        </li>
        <li>
          <a href="/service" className="hover:text-yellow-400">
            Services
          </a>
        </li>
        <li>
          <a href="/about" className="hover:text-yellow-400">
            About Us
          </a>
        </li>
        <li>
          <a href="/testimonial" className="hover:text-yellow-400">
            Testimonial
          </a>
        </li>
        <li>
          <a href="/contact" className="hover:text-yellow-400">
            Contact
          </a>
        </li>

        <li>
          <a
            href="/contact"
            className="bg-yellow-400 text-black px-4 py-2 rounded-full hover:bg-yellow-300 transition"
          >
            LET'S TALK
          </a>
        </li>

        <li>
          <button
            onClick={() => window.open("/catalogue SS.pdf", "_blank")}
            className="border border-yellow-400 px-4 py-2 rounded-full hover:bg-yellow-400 hover:text-black transition"
          >
            Catalogue
          </button>
        </li>
      </ul>

      {/* MOBILE BUTTON */}
      <button className="lg:hidden text-3xl" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      {/* MOBILE MENU OVERLAY */}
      <div
        className={`z-40 fixed inset-0 bg-black/95 backdrop-blur-md transform transition-transform duration-300 lg:hidden ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Close Button */}
        <button className="absolute top-5 right-5 text-3xl" onClick={closeMenu}>
          ✕
        </button>

        <ul className="flex flex-col items-center justify-center h-full gap-6 text-lg uppercase">
          <li>
            <a onClick={closeMenu} href="/">
              Home
            </a>
          </li>
          <li>
            <a onClick={closeMenu} href="/work">
              Works
            </a>
          </li>
          <li>
            <a onClick={closeMenu} href="/service">
              Services
            </a>
          </li>
          <li>
            <a onClick={closeMenu} href="/about">
              About Us
            </a>
          </li>
          <li>
            <a onClick={closeMenu} href="/testimonial">
              Testimonial
            </a>
          </li>
          <li>
            <a onClick={closeMenu} href="/contact">
              Contact
            </a>
          </li>

          <li>
            <a
              onClick={closeMenu}
              href="/contact"
              className="bg-yellow-400 text-black px-6 py-3 rounded-full"
            >
              LET'S TALK
            </a>
          </li>

          <li>
            <button
              onClick={() => {
                window.open("/catalogue SS.pdf", "_blank");
                closeMenu();
              }}
              className="border border-yellow-400 px-5 py-2 rounded-full"
            >
              Catalogue
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
